import {Doughnut, mixins} from 'vue-chartjs'

const { reactiveProp } = mixins

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['chartData','options', 'customOptions'],
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object

    this.renderChart(this.chartData, this.localOptions)
  },

  computed: {
    localOptions: function () {
      let ret = this.options;
      if (this.customOptions) {
        let options_nd = {
          tooltips: {
            callbacks: {
              label: this.customOptions
            }
          }
        }
        ret = {...this.options, ...options_nd}
      }
      return ret;
    }

  }
}
